import React from 'reactn';
import Notification from "shared-anpost-components/components/notification";

const ReceivedItemsInfoBanner = () => {
  return (
    <Notification
      colour="blue"
      text="An Post has not received your item yet"
      additionalText="As soon as the item is received An Post will process it for delivery."
      ctaText="Find out more"
      ctaLink={`${window.location.origin}/Help-Support/Track-and-Trace`}
      ctaVisuallyHiddenText=" about why your item may not have been received yet"
      ctaClassName="gtm-linkclick"
    />
  );
};

export default ReceivedItemsInfoBanner;